import React from "react";
import LogRocket from "logrocket";
import { useUserContext } from '~/authentication/UserProvider';

const logrocketId = process.env.REACT_APP_LOGROCKET_APP_ID;
if (logrocketId) {
  LogRocket.init(logrocketId);
}

// Create a wrapper component to handle LogRocket user identification
function LogRocketProvider({ children }) {
  const { firebaseUser, tradersUserData } = useUserContext();

  React.useEffect(() => {
    if (firebaseUser && tradersUserData) {
      LogRocket.identify(firebaseUser.uid, {
        email: firebaseUser.email,
        name: `${tradersUserData.firstName} ${tradersUserData.lastName}`,
      });
    }
  }, [firebaseUser, tradersUserData]);

  return children;
}

export default LogRocketProvider;